import { menu as types } from '../../constants/types'
const menu = {
    type: 0,
}
const reducer = (state = menu, action) => {
    switch (action.type) {
        case types.CHANGE: return { type: action.payload };
        default: return state;
    }
};
export default reducer